export enum PremadePaperLevel {
  tahap1 = 'Tahap 1',
  tahap2 = 'Tahap 2',
  PT3 = 'PT3',
  SPM = 'SPM',
}

const getLevelPremadePaper = (level: number) => {
  //NOTE: To handle for chapter that does nat has from (only by elementary, lowerform or upperform)
  if (level < 0) {
    if (level === -1) {
      return PremadePaperLevel.tahap1;
    } else if (level === -2) {
      return PremadePaperLevel.tahap2;
    } else if (level === -3) {
      return PremadePaperLevel.PT3;
    } else if (level === -4) {
      return PremadePaperLevel.SPM;
    }
  }

  let prefix = 'Year';

  if (level > 6) {
    prefix = 'Form';
    level -= 6;
  }

  return `${prefix} ${level}`;
};

export default getLevelPremadePaper;
